











import { Vue, Component, Prop } from 'vue-property-decorator'
import { TitleBlockModel } from '../models'

@Component({
  components: {
  }
})

export default class TitleBlock extends Vue {
  @Prop() titles: TitleBlockModel
  @Prop() isLeft: boolean
  @Prop() isWhite: boolean
  @Prop() isLarge: boolean
  @Prop() isSmall: boolean
}
